// package: friendemic.api.response
// file: friendemic/api/response/review_response_ticket.proto
"use strict";

exports.SubmittedAtFriendly = {
  enumMap: {
		0: "0-8 hours",
		1: "8-16 hours",
		2: "16-24 hours",
		4: "24-48 hours",
		5: "2-7 days",
		6: "7-30 days",
		7: "30-45 days",
  },
  friendlyMap: {
		"0-8 hours": 0,
		"8-16 hours": 1,
		"16-24 hours": 2,
		"24-48 hours": 4,
		"2-7 days": 5,
		"7-30 days": 6,
		"30-45 days": 7,
  },
  toFriendly: function(e) {
    const v = this.enumMap[e]
    if (v === undefined) {
      throw new Error(e + ' is not a valid ReviewResponseTicketFilters.SubmittedAt enum option')
    }

    return v
  },
  toEnum: function(v) {
    const e = this.friendlyMap[v]
    if (e === undefined) {
      throw new Error('\'' + v + '\'' + ' is not a valid ReviewResponseTicketFilters.SubmittedAt friendly value')
    }

    return e
  }
}
